export default __webpack_public_path__ + "static/howltsans-b-b5fac8b5459b5f6fda89d878608231ea.eot";